/**
 * Resolve tenant identifier for reports/exports (client ESM mirror).
 */
export function resolveReportTenant(project, snapshot) {
  const p = project && typeof project === "object" ? project : {};
  const s = snapshot && typeof snapshot === "object" ? snapshot : {};
  const org = p.org && typeof p.org === "object" ? p.org : {};

  const candidates = [
    org.url,
    s.tenantIdentifier,
    s.tenant_identifier,
    s.tenantId,
    s.oktaUrl,
    s.orgUrl,
    s.auth0Domain,
    s.oryProjectSlug,
    s.oryProjectId,
    p.auth0Domain,
    p.tenantId,
    org.name,
  ];

  for (const value of candidates) {
    const text = String(value || "").trim();
    if (text) return text;
  }
  return "";
}
